import {
  TASK_MESSAGE_TYPE_EMAIL,
  TASK_MESSAGE_TYPE_SMS
} from 'Api/beAutomationApi'
import {
  getTimeObj,
  jsDateTotringUTC,
  withoutOffsetToString
} from 'Helpers/dates'
import getIntl from 'Helpers/intl'
import { logAppError } from 'Helpers/logger'
import {
  toastShow,
  TOAST_VARIANT_ERROR,
  TOAST_VARIANT_WARNING,
  TOAST_VARIANT_SUCCESS
} from 'mailup-web-components'
import {
  storeGet,
  STORE_KEY_LIST,
  STORE_KEY_ACCOUNT,
  notifyParent,
  fromUTCtoZoneFormatted,
  STORE_KEY_ID_LIST,
  evalCondition,
  regexEmail
} from 'mailup-react-helpers'
import {
  addGroup,
  addNewTag,
  fetchDynamicFieldsAction,
  getAllTags,
  getTaskAction,
  getListAction,
  getPecPlusConfigAction,
  fetchMessageDetailsById,
  getFilters,
  getListOfFiltersAction,
  copyMessage,
  copySmsMessage,
  fetchSmsEntitiesThatUseMessage,
  fetchEmailEntitiesThatUseMessage,
  listRssFeedByIdListAction,
  getMessageMinimumDetailsAction,
  getGroupByIdAction,
  saveTask,
  updateTask,
  setTaskEnable,
  senderEmailStatus,
  simulate,
  simulateAsync
} from '../actions/actions'
import { modalSimulate, modalUsedMessageState } from '../state/modals'
import { pageState } from '../state/page'
import {
  ACTION_SEND_MESSAGE,
  ACTION_SEND_SMS,
  anagFiltersState,
  dynamicFieldState,
  exceptionsState,
  filtersState,
  otherFiltersState,
  recapState,
  rssFeedsState,
  senderConfigState,
  tagsListState,
  taskConditionsState,
  taskPanelFrequencyState,
  taskState
} from '../state/task'
import { TRUSTED_SENDER_STATUS_DELIVER_OK } from 'Api/beSendApi'
import { POLLING_MAX_ITERATION, POLLING_MAX_INTERVAL } from 'Constants/'
import {
  ANY_ITEM,
  COPY,
  DO_NOTHING,
  EMPTYGROUP,
  modalEndConditionState,
  MOVE
} from 'Hooks/useModalEndCondition/useModalEndCondition'
import { getAllAvailableFilterTypes } from 'Api/beFiltersApi'
import { pendoTrack } from 'Helpers/pendoTracking'

export const changeWizardStepCallback =
  ({ set, snapshot }) =>
  async (nextStep) => {
    const { idTask } = await snapshot.getPromise(pageState)

    if (idTask > 0) {
      const modalEndCondition = await snapshot.getPromise(
        modalEndConditionState
      )
      const task = await snapshot.getPromise(taskState)
      const senderConfig = await snapshot.getPromise(senderConfigState)
      const exceptionState = await snapshot.getPromise(exceptionsState)
      const taskConditions = await snapshot.getPromise(taskConditionsState)
      // solo aggiornamento dello stato, non salva mai
      updateTaskStep2(
        modalEndCondition,
        task,
        senderConfig,
        idTask,
        set,
        taskState,
        false
      )
      updateTaskStep3(taskConditions, set, taskState, false)
      updateTaskStep4(task, set, taskState, exceptionState, false)
    }

    set(pageState, (prev) => ({ ...prev, wizardStep: nextStep }))
  }

export const resetPageCallback =
  ({ reset }) =>
  async () => {
    reset(taskState)
    reset(pageState)
    reset(tagsListState)
    reset(senderConfigState)
    reset(taskConditionsState)
    reset(exceptionsState)
    reset(recapState)
  }

export const initPageCallback =
  ({ set }) =>
  async (idTask) => {
    idTask = idTask ? parseInt(idTask) : 0
    set(pageState, (prev) => ({
      ...prev,
      loading: true,
      loaded: false,
      error: false,
      idTask
    }))

    try {
      const [
        tagsList,
        taskData,
        fetchDynamicFieldsResp,
        listData,
        pecPlusConfig,
        filters,
        allFilters,
        rssFeeds
      ] = await Promise.all([
        getAllTags(),
        idTask > 0 ? getTaskAction(idTask) : null,
        fetchDynamicFieldsAction(),
        getListAction(),
        getPecPlusConfigAction(),
        getFilters(),
        getListOfFiltersAction({
          types: getAllAvailableFilterTypes(),
          pageSize: 0,
          pageNumber: 1,
          orderBy: 'Name',
          orderDescending: false
        }),
        listRssFeedByIdListAction({ pageSize: 0, pageNumber: 1 })
      ])
      const IdList = parseInt(storeGet(STORE_KEY_ID_LIST))
      if (idTask > 0) {
        const choosenDays = []

        if (taskData.Frequency.KindDateFrequency === 'w') {
          taskData.Frequency.FrequencyWeeklyChoosenDay.map((e) =>
            choosenDays.push({ DayOfWeek: e.Day })
          )
        } else if (taskData.Frequency.KindDateFrequency === 'm') {
          taskData.Frequency.FrequencyMonthlyChoosenDay.map((e) =>
            choosenDays.push({
              DayOfMonth: e.DayOfMonth,
              DayOfWeek: e.DayOfWeek,
              WeekOfMonth: e.WeekOfMonth,
              FixedDay: e.DayOfMonth > 0
            })
          )
        } else if (taskData.Frequency.KindDateFrequency === 'y') {
          taskData.Frequency.FrequencyYearlyChoosenDay.map((e) =>
            choosenDays.push({
              DayOfMonth: e.DayOfMonth,
              Month: e.Month,
              DayOfWeek: e.DayOfWeek,
              WeekOfMonth: e.WeekOfMonth,
              FixedDay: e.DayOfMonth > 0
            })
          )
        }

        // copy/move

        const objModelCopy = {
          label: '',
          value: -1
        }
        const objModelEmpty = {
          label: '',
          value: -1
        }
        const objModelMoveFrom = {
          label: '',
          value: -1
        }
        const objModelMoveTo = {
          label: '',
          value: -1
        }
        let check = DO_NOTHING
        // devo prevdere il caso con 0 e quindi prendo aggiungere anyItems
        const newGroupItems = []
        newGroupItems.push(ANY_ITEM)

        // cerco nella lista locale, prima pagina
        let endFromGroup = newGroupItems.find(
          (el) => el.value === taskData.Detail.FromGroup
        )
        let endToGroup = newGroupItems.find(
          (el) => el.value === taskData.Detail.ToGroup
        )

        if (taskData.Detail.FromGroup === -1 && taskData.Detail.ToGroup > 0) {
          check = COPY
          if (!endToGroup) {
            // non presente nella lista locale, cerco su API
            endToGroup = await getGroupByIdAction(taskData.Detail.ToGroup)
            newGroupItems.push(endToGroup)
          }
          objModelCopy.label = endToGroup.label
          objModelCopy.value = taskData.Detail.ToGroup
        } else if (
          taskData.Detail.FromGroup > -1 &&
          taskData.Detail.ToGroup > 0
        ) {
          check = MOVE
          if (!endFromGroup && taskData.Detail.FromGroup > 0) {
            // non presente nella lista locale, cerco su API
            endFromGroup = await getGroupByIdAction(taskData.Detail.FromGroup)
            newGroupItems.push(endFromGroup)
          }
          if (!endToGroup) {
            // non presente nella lista locale, cerco su API
            endToGroup = await getGroupByIdAction(taskData.Detail.ToGroup)
            newGroupItems.push(endToGroup)
          }
          objModelMoveFrom.label =
            taskData.Detail.FromGroup > 0 ? endFromGroup.label : ''
          objModelMoveFrom.value = taskData.Detail.FromGroup
          objModelMoveTo.label = endToGroup.label
          objModelMoveTo.value = taskData.Detail.ToGroup
        } else if (
          taskData.Detail.FromGroup > 0 &&
          taskData.Detail.ToGroup === -1
        ) {
          check = EMPTYGROUP
          if (!endFromGroup) {
            // non presente nella lista locale, cerco su API
            endFromGroup = await getGroupByIdAction(taskData.Detail.FromGroup)
            newGroupItems.push(endFromGroup)
          }
          objModelEmpty.label = endFromGroup.label
          objModelEmpty.value = taskData.Detail.FromGroup
        }
        set(modalEndConditionState, (prev) => ({
          ...prev,
          check,
          copyValue: objModelCopy,
          emptyValue: objModelEmpty,
          moveFromValue: objModelMoveFrom,
          moveToValue: objModelMoveTo,
          items: newGroupItems
        }))

        set(taskState, {
          ...taskData,
          IdList,
          Tags: taskData.Tags ? taskData.Tags : [],
          enableIdFieldUTCCode: taskData.Detail.IdFieldUTCCode > 0,
          Frequency: {
            ...taskData.Frequency,
            ChoosenDays: choosenDays
          }
        })
      } else {
        set(taskState, (prev) => ({
          ...prev,
          IdList,
          CustomerTimeZone: storeGet(STORE_KEY_LIST).TimeZoneCode,
          Detail: {
            ...prev.Detail,
            Sender: listData,
            SenderName: '',
            ReplyTo: ''
          }
        }))
      }

      set(exceptionsState, (prev) => ({
        ...prev,
        activiteFor: taskData && taskData.EndDate ? 'FromToDate' : 'FromDate',
        StartDate:
          taskData && taskData.StartDate
            ? jsDateTotringUTC(taskData.StartDate)
            : prev.StartDate,
        EndDate:
          taskData && taskData.EndDate
            ? jsDateTotringUTC(taskData.EndDate)
            : prev.EndDate,
        FrequencyBlackoutDate:
          taskData && taskData.Frequency.FrequencyBlackoutDate
            ? taskData.Frequency.FrequencyBlackoutDate
            : prev.FrequencyBlackoutDate,
        NotInWeekends: taskData && taskData.Frequency.NotInWeekends,
        urlFrequencyEnabled: !!(taskData && taskData.Frequency.Url),
        Url:
          taskData && taskData.Frequency.Url
            ? taskData.Frequency.Url
            : prev.Url,
        UrlFrequency:
          taskData && taskData.Frequency.UrlFrequency
            ? taskData.Frequency.UrlFrequency
            : prev.UrlFrequency,
        frequencyBlackoutHourEnabled:
          taskData &&
          taskData.Frequency.BlackoutEndHour &&
          taskData.Frequency.BlackoutStartHour,
        startBOTime:
          taskData && taskData.Frequency.BlackoutStartHour
            ? getTimeObj(taskData.Frequency.BlackoutStartHour)
            : prev.startBOTime,
        endBOTime:
          taskData && taskData.Frequency.BlackoutEndHour
            ? getTimeObj(taskData.Frequency.BlackoutEndHour)
            : prev.endBOTime,
        KindOfUrl: taskData ? taskData.Frequency.KindOfUrl : prev.KindOfUrl
      }))

      set(tagsListState, (prev) => ({ ...prev, tagsList: tagsList.Items }))
      set(dynamicFieldState, fetchDynamicFieldsResp.dynamicFields)

      set(filtersState, filters)
      set(anagFiltersState, {
        items: allFilters.Items.filter((f) => f.Type === 'Anagraphic').map(
          (m) => ({ value: m.Id, label: m.Id + ' - ' + m.Name })
        )
      })
      set(otherFiltersState, {
        items: allFilters.Items.filter((f) => f.Type !== 'Anagraphic').map(
          (m) => ({ value: m.Id, label: m.Id + ' - ' + m.Name })
        )
      })
      set(rssFeedsState, {
        items: rssFeeds.Items.map((m) => ({ value: m.Url, label: m.Title }))
      })

      if (idTask > 0 && taskData.Detail.Action === -1) {
        set(senderConfigState, (prev) => ({
          ...prev,
          SenderEmail: listData.SenderEmail,
          SenderName: listData.SenderName,
          SenderNameSMS: listData.SenderNameSMS,
          SenderReplyTo: listData.SenderReplyTo,
          IsPecPlus: pecPlusConfig && pecPlusConfig.Status,
          CustomSender: taskData.Detail.CustomSender,
          IdMessage: taskData.Detail.IdMessage,
          listData,
          previousAction: taskData.Detail.Action,
          IdSenderNameField: taskData.Detail.IdSenderNameField,
          IdSenderEmailField: taskData.Detail.IdSenderEmailField
        }))
      } else {
        set(senderConfigState, (prev) => ({
          ...prev,
          SenderEmail:
            idTask > 0
              ? taskData.Detail.Action === 0
                ? taskData.Detail.Sender
                : listData.SenderEmail
              : listData.SenderEmail,
          SenderName:
            idTask > 0
              ? taskData.Detail.Action === 0
                ? taskData.Detail.SenderName
                : listData.SenderName
              : listData.SenderName,
          SenderNameSMS:
            idTask > 0
              ? taskData.Detail.Action === 0
                ? listData.SenderNameSMS
                : taskData.Detail.Sender
              : listData.SenderNameSMS,
          SenderReplyTo:
            idTask > 0
              ? taskData.Detail.Action === 0
                ? taskData.Detail.ReplyTo
                : listData.SenderReplyTo
              : listData.SenderReplyTo,
          IsPecPlus: pecPlusConfig && pecPlusConfig.Status,
          CustomSender: idTask > 0 ? taskData.Detail.CustomSender : false,
          IdMessage: idTask > 0 ? taskData.Detail.IdMessage : 0,
          listData,
          IdSenderNameField: idTask > 0 ? taskData.Detail.IdSenderNameField : 0,
          IdSenderEmailField:
            idTask > 0 ? taskData.Detail.IdSenderEmailField : 0
        }))
      }

      set(taskConditionsState, (prev) => ({
        ...prev,
        IncludeGroups:
          idTask > 0 && taskData.Detail.Group
            ? taskData.Detail.Group.filter((f) => f.Action === 0).map(
                (m) => m.IdGroup
              )
            : prev.IncludeGroups,
        ExcludeGroups:
          idTask > 0 && taskData.Detail.Group
            ? taskData.Detail.Group.filter((f) => f.Action === 1).map(
                (m) => m.IdGroup
              )
            : prev.ExcludeGroups,
        Filters:
          idTask > 0 && taskData.Detail.Filter
            ? taskData.Detail.Filter.map((m) => m.IdFilter)
            : prev.Filters,
        FilterConditionsRules:
          idTask > 0 && taskData.Detail.FilterConditionsRules
            ? taskData.Detail.FilterConditionsRules
            : prev.FilterConditionsRules,
        FrequencySafeGuard:
          idTask > 0
            ? taskData.Detail.FrequencySafeGuard
            : prev.FrequencySafeGuard,
        FrequencySafeGuardHour:
          idTask > 0
            ? taskData.Detail.FrequencySafeGuard <= 0
              ? 1
              : taskData.Detail.FrequencySafeGuard
            : prev.FrequencySafeGuard,
        ApplyConditionsRule:
          idTask > 0 && taskData.Detail.ApplyConditionsRule
            ? taskData.Detail.ApplyConditionsRule
            : prev.ApplyConditionsRule,
        ApplyConditionsEvent:
          idTask > 0 && taskData.Detail.ApplyConditionsEvent
            ? taskData.Detail.ApplyConditionsEvent
            : prev.ApplyConditionsEvent,
        TaskApplyConditionsEvent:
          idTask > 0 && taskData.Detail.TaskApplyConditionsEvent
            ? taskData.Detail.TaskApplyConditionsEvent
            : prev.TaskApplyConditionsEvent,
        ApplyConditionsField:
          idTask > 0
            ? taskData.Detail.ApplyConditionsField
            : prev.ApplyConditionsField,
        TaskApplyConditionsField:
          idTask > 0 && taskData.Detail.TaskApplyConditionsField
            ? taskData.Detail.TaskApplyConditionsField
            : prev.TaskApplyConditionsField,
        AnagFilterTrue:
          idTask > 0
            ? taskData.Detail.ApplyConditionsFilter &&
              taskData.Detail.TaskApplyConditionsFilter &&
              taskData.Detail.TaskApplyConditionsFilter.filter(
                (f) => f.TypeOfFilter === 0 && f.Action === 0
              ).length > 0
            : prev.AnagFilterTrue,
        AnagFilterTrueId:
          idTask > 0
            ? taskData.Detail.ApplyConditionsFilter &&
              taskData.Detail.TaskApplyConditionsFilter &&
              taskData.Detail.TaskApplyConditionsFilter.find(
                (f) => f.TypeOfFilter === 0 && f.Action === 0
              )
              ? taskData.Detail.ApplyConditionsFilter &&
                taskData.Detail.TaskApplyConditionsFilter &&
                taskData.Detail.TaskApplyConditionsFilter.find(
                  (f) => f.TypeOfFilter === 0 && f.Action === 0
                ).IdFilter
              : 0
            : prev.AnagFilterTrueId,
        AnagFilterFalse:
          idTask > 0
            ? taskData.Detail.ApplyConditionsFilter &&
              taskData.Detail.TaskApplyConditionsFilter &&
              taskData.Detail.TaskApplyConditionsFilter.filter(
                (f) => f.TypeOfFilter === 0 && f.Action === 1
              ).length > 0
            : prev.AnagFilterFalse,
        AnagFilterFalseId:
          idTask > 0
            ? taskData.Detail.ApplyConditionsFilter &&
              taskData.Detail.TaskApplyConditionsFilter &&
              taskData.Detail.TaskApplyConditionsFilter.find(
                (f) => f.TypeOfFilter === 0 && f.Action === 1
              )
              ? taskData.Detail.ApplyConditionsFilter &&
                taskData.Detail.TaskApplyConditionsFilter &&
                taskData.Detail.TaskApplyConditionsFilter.find(
                  (f) => f.TypeOfFilter === 0 && f.Action === 1
                ).IdFilter
              : 0
            : prev.AnagFilterFalseId,
        OtherFilterTrue:
          idTask > 0
            ? taskData.Detail.ApplyConditionsFilter &&
              taskData.Detail.TaskApplyConditionsFilter &&
              taskData.Detail.TaskApplyConditionsFilter.filter(
                (f) => f.TypeOfFilter === 1 && f.Action === 0
              ).length > 0
            : prev.OtherFilterTrue,
        OtherFilterTrueId:
          idTask > 0
            ? taskData.Detail.ApplyConditionsFilter &&
              taskData.Detail.TaskApplyConditionsFilter &&
              taskData.Detail.TaskApplyConditionsFilter.find(
                (f) => f.TypeOfFilter === 1 && f.Action === 0
              )
              ? taskData.Detail.ApplyConditionsFilter &&
                taskData.Detail.TaskApplyConditionsFilter &&
                taskData.Detail.TaskApplyConditionsFilter.find(
                  (f) => f.TypeOfFilter === 1 && f.Action === 0
                ).IdFilter
              : 0
            : prev.OtherFilterTrueId,
        OtherFilterFalse:
          idTask > 0
            ? taskData.Detail.ApplyConditionsFilter &&
              taskData.Detail.TaskApplyConditionsFilter &&
              taskData.Detail.TaskApplyConditionsFilter.filter(
                (f) => f.TypeOfFilter === 1 && f.Action === 1
              ).length > 0
            : prev.OtherFilterFalse,
        OtherFilterFalseId:
          idTask > 0
            ? taskData.Detail.ApplyConditionsFilter &&
              taskData.Detail.TaskApplyConditionsFilter &&
              taskData.Detail.TaskApplyConditionsFilter.find(
                (f) => f.TypeOfFilter === 1 && f.Action === 1
              )
              ? taskData.Detail.ApplyConditionsFilter &&
                taskData.Detail.TaskApplyConditionsFilter &&
                taskData.Detail.TaskApplyConditionsFilter.find(
                  (f) => f.TypeOfFilter === 1 && f.Action === 1
                ).IdFilter
              : 0
            : prev.OtherFilterTrueId
      }))
    } catch (error) {
      logAppError({
        Component: 'Task',
        Method: 'initPageCallback',
        appError: error
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }

    set(pageState, (prev) => ({
      ...prev,
      loading: false,
      loaded: true,
      wizardStep: idTask > 0 ? 5 : 1
    }))
  }

export const addNewTagCallback =
  ({ set, snapshot }) =>
  async (pTagName) => {
    const { Tags } = await snapshot.getPromise(taskState)

    try {
      const newTag = await addNewTag(pTagName)
      const tagsList = await getAllTags()

      set(tagsListState, (prev) => ({ ...prev, tagsList: tagsList.Items }))

      set(taskState, (prev) => ({
        ...prev,
        Tags: [...Tags, newTag.Id]
      }))
    } catch (error) {
      logAppError({
        Component: 'Task',
        Method: 'addNewTagCallback',
        appError: error
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }
  }

export const addGroupCallback =
  ({ set }) =>
  async ({ name, notes, testGroup }) => {
    set(pageState, (prev) => ({
      ...prev,
      loading: true
    }))

    try {
      await addGroup(name, notes, testGroup)
    } catch (error) {
      logAppError({
        Component: 'Task',
        Method: 'addGroupCallback',
        appError: error
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }

    set(pageState, (prev) => ({
      ...prev,
      loading: false
    }))
  }

export const errorCallback =
  ({ set }) =>
  async (error) => {
    logAppError({
      appError: error,
      Component: 'Task',
      Method: 'errorCallback'
    })

    set(pageState, (prev) => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }

export const editMessageDetailsByIdCallback =
  ({ set }) =>
  async (IdMessage) => {
    set(pageState, (prev) => ({
      ...prev,
      loading: true
    }))
    const { Domain } = storeGet(STORE_KEY_ACCOUNT)
    try {
      const messageDetails = await fetchMessageDetailsById(IdMessage)

      if (messageDetails) {
        if (messageDetails.IsBee) {
          const route = `messages_app_redirector.aspx?r=/messages/email/bee/edit/${encodeURIComponent(
            IdMessage
          )}`

          notifyParent('openNewTab', [
            `https://${Domain}/console/Main.aspx#/main?pageId=EmailMessageBeeEdit&pageHref=${encodeURIComponent(
              route
            )}`
          ])
        } else {
          const route = `form_upd_newsletter.aspx?isNew=true&idNL=${encodeURIComponent(
            IdMessage
          )}`
          notifyParent('openNewTab', [
            `https://${Domain}/console/Main.aspx#/main?pageId=EmailMessageEditHtml&pageHref=${encodeURIComponent(
              route
            )}`
          ])
        }
      }
    } catch (error) {
      logAppError({
        appError: error,
        Component: 'Task',
        Method: 'editMessageDetailsByIdCallback'
      })

      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }
    set(pageState, (prev) => ({
      ...prev,
      loading: false
    }))
  }

export const getEmailSelectedMessageCallback =
  ({ set }) =>
  async (idMessage) => {
    let found = false
    set(pageState, (prev) => ({
      ...prev,
      loading: true
    }))

    try {
      const emailEntities = await fetchEmailEntitiesThatUseMessage(idMessage)

      let entityName = ''
      let entityType = ''

      if (emailEntities && emailEntities.length > 0) {
        emailEntities.forEach((element) => {
          if (
            !found &&
            (element.Type.toLowerCase() ===
              'AutomationWorkflow'.toLowerCase() ||
              element.Type.toLowerCase() === 'Trigger'.toLowerCase()) &&
            element.Id !== idMessage
          ) {
            entityName = element.Name
            entityType = element.Type
            found = true
          }
        })
      }

      if (found) {
        // usato
        set(modalUsedMessageState, (prev) => ({
          ...prev,
          show: true,
          entityName,
          entityType,
          type: TASK_MESSAGE_TYPE_EMAIL,
          idMessage
        }))
      } else {
        set(senderConfigState, (prev) => ({
          ...prev,
          IsDirty: true,
          IdMessage: idMessage,
          idMessageIsDirty: true
        }))
      }
    } catch (error) {
      logAppError({
        appError: error,
        Component: 'Task',
        Method: 'getEmailSelectedMessageCallback'
      })

      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }
    set(pageState, (prev) => ({
      ...prev,
      loading: false
    }))
    return found // true: trovato - false vado avanti
  }

export const getSmsSelectedMessageCallback =
  ({ set }) =>
  async (idMessage) => {
    set(pageState, (prev) => ({
      ...prev,
      loading: true
    }))
    let found = false
    try {
      const smsEntities = await fetchSmsEntitiesThatUseMessage(idMessage)
      // esiste Entities[i].Type=='Trigger' || esiste Entities[i].Type=='AutomationWorkflow') && Entities[i].Id != ID
      let entityName = ''
      let entityType = ''

      if (smsEntities && smsEntities.length > 0) {
        smsEntities.forEach((element) => {
          if (
            !found &&
            (element.Type.toLowerCase() ===
              'AutomationWorkflow'.toLowerCase() ||
              element.Type.toLowerCase() === 'Trigger'.toLowerCase()) &&
            element.Id !== idMessage
          ) {
            entityName = element.Name
            entityType = element.Type
            found = true
          }
        })
      }

      if (found) {
        // usato
        set(modalUsedMessageState, (prev) => ({
          ...prev,
          show: true,
          entityName,
          entityType,
          type: TASK_MESSAGE_TYPE_SMS,
          idMessage
        }))
      } else {
        set(senderConfigState, (prev) => ({
          ...prev,
          IsDirty: true,
          IdMessage: idMessage,
          idMessageIsDirty: true
        }))
      }
    } catch (error) {
      logAppError({
        appError: error,
        Component: 'Task',
        Method: 'getSmsSelectedMessageCallback'
      })

      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }
    set(pageState, (prev) => ({
      ...prev,
      loading: false
    }))
    return found
  }

export const copyMessageCallback =
  ({ snapshot, set }) =>
  async () => {
    set(pageState, (prev) => ({
      ...prev,
      loading: true
    }))

    try {
      const { entityName, entityType, idMessage } = await snapshot.getPromise(
        modalUsedMessageState
      )
      const { TimeZoneCode: tzcode } = storeGet(STORE_KEY_LIST)
      let str = ''
      switch (entityType.toLowerCase()) {
        case 'Trigger'.toLowerCase():
          str = getIntl().formatMessage({
            id: 'Load.EmailMessage.CopyTriggerMessageNote'
          })
          break
        case 'AutomationWorkflow'.toLowerCase():
          str = getIntl().formatMessage({
            id: 'Load.EmailMessage.CopyWorkflowMessageNote'
          })
          break
        default:
          break
      }
      const notes = str
        .replace('{0}', idMessage)
        .replace(
          '{1}',
          fromUTCtoZoneFormatted(new Date(), tzcode, 'YYYY-MM-DD HH:mm:ss')
        )
        .replace('{2}', entityName)

      const ret = await copyMessage(idMessage, notes)

      set(senderConfigState, (prev) => ({
        ...prev,
        IsDirty: true,
        IdMessage: ret.IdMessage,
        idMessageIsDirty: true
      }))
    } catch (error) {
      logAppError({
        appError: error,
        Component: 'Task',
        Method: 'copyMessageCallback'
      })

      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }

    set(pageState, (prev) => ({
      ...prev,
      loading: false
    }))
  }

export const copyMessageSmsCallback =
  ({ snapshot, set }) =>
  async () => {
    set(pageState, (prev) => ({
      ...prev,
      loading: true
    }))

    try {
      const { entityName, entityType, idMessage } = await snapshot.getPromise(
        modalUsedMessageState
      )
      const { TimeZoneCode: tzcode } = storeGet(STORE_KEY_LIST)
      let str = ''
      switch (entityType.toLowerCase()) {
        case 'Trigger'.toLowerCase():
          str = getIntl().formatMessage({
            id: 'Load.EmailMessage.CopyTriggerMessageNote'
          })
          break
        case 'AutomationWorkflow'.toLowerCase():
          str = getIntl().formatMessage({
            id: 'Load.EmailMessage.CopyWorkflowMessageNote'
          })
          break
        default:
          break
      }
      const notes = str
        .replace('{0}', idMessage)
        .replace(
          '{1}',
          fromUTCtoZoneFormatted(new Date(), tzcode, 'YYYY-MM-DD HH:mm:ss')
        )
        .replace('{2}', entityName)

      const ret = await copySmsMessage(idMessage, notes)

      set(senderConfigState, (prev) => ({
        ...prev,
        IsDirty: true,
        IdMessage: ret.Id,
        idMessageIsDirty: true
      }))
    } catch (error) {
      logAppError({
        appError: error,
        Component: 'Task',
        Method: 'copyMessageSmsCallback'
      })

      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }
    set(pageState, (prev) => ({
      ...prev,
      loading: false
    }))
  }

export const getMessageDetailCallback =
  ({ snapshot, set }) =>
  async (id) => {
    try {
      const resp = await fetchMessageDetailsById(id)

      set(recapState, (prev) => ({
        ...prev,
        subject: resp.Subject
      }))
    } catch (error) {
      logAppError({
        appError: error,
        Component: 'Task',
        Method: 'getMessageDetailCallback'
      })
    }
  }

export const getSmsDetailCallback =
  ({ snapshot, set }) =>
  async (id) => {
    try {
      const resp = await getMessageMinimumDetailsAction(id)

      set(recapState, (prev) => ({
        ...prev,
        subject: resp.Subject
      }))
    } catch (error) {
      logAppError({
        appError: error,
        Component: 'Task',
        Method: 'getSmsDetailCallback'
      })
    }
  }

export const getGroupByIdCallback =
  ({ snapshot, set }) =>
  async (id) => {
    try {
      const resp = await getGroupByIdAction(id)
      return resp
    } catch (error) {
      logAppError({
        appError: error,
        Component: 'Task',
        Method: 'getSmsDetailCallback'
      })
    }
  }

export const getFiltersCallback =
  ({ snapshot, set }) =>
  async () => {
    try {
      const resp = await getFilters()
      return resp.options
    } catch (error) {
      logAppError({
        appError: error,
        Component: 'Task',
        Method: 'getSmsDetailCallback'
      })
    }
  }

export const saveTaskCallback =
  ({ snapshot, set }) =>
  async (exitPage) => {
    set(pageState, (prev) => ({
      ...prev,
      loading: true
    }))
    set(taskState, (prev) => ({
      ...prev,
      saveTask: false
    }))
    let ret = false
    const task = await snapshot.getPromise(taskState)
    const { idTask } = await snapshot.getPromise(pageState)
    const { IsPecPlus } = await snapshot.getPromise(senderConfigState)

    try {
      const isNLactive = evalCondition('uo:NL')
      const isSMSactive = evalCondition('uo:SMS')

      const validEmail =
        task.Detail.ReplyTo && task.Detail.ReplyTo.match(regexEmail)

      if (
        (task.Detail.Action === 0 && !isNLactive) ||
        (task.Detail.Action === 1 && !isSMSactive)
      ) {
        toastShow(
          getIntl().formatMessage({
            id: 'Load.TriggersDetail.AlertPermission'
          }),
          TOAST_VARIANT_ERROR,
          'AlertPermission'
        )
        set(pageState, (prev) => ({
          ...prev,
          loading: false
        }))
        return false
      }

      const trustedEmailSendersActive = evalCondition('co:TRUSTEDEMAILSENDERS')
      const trusted =
        task.Detail.Action === 0
          ? await senderEmailStatus(task.Detail.Sender)
          : true

      if (
        trustedEmailSendersActive === true &&
        task.Detail.Action === 0 &&
        !IsPecPlus &&
        trusted !== TRUSTED_SENDER_STATUS_DELIVER_OK
      ) {
        toastShow(
          getIntl().formatMessage({
            id: 'Load.EmailSenderSelector.EmailWarningSave'
          }),
          TOAST_VARIANT_WARNING,
          'EmailWarningSave'
        )
        set(pageState, (prev) => ({
          ...prev,
          loading: false
        }))
      } else if (
        task.Detail.Action === 0 &&
        (!validEmail || !task.Detail.ReplyTo) &&
        !IsPecPlus
      ) {
        toastShow(
          getIntl().formatMessage({
            id: 'Load.TriggersDetail.EmailReplyToWarningSave'
          }),
          TOAST_VARIANT_WARNING,
          'EmailReplyToWarningSave'
        )
        set(pageState, (prev) => ({
          ...prev,
          loading: false
        }))
      } else {
        // if (task.Detail.Action != 1 || $scope.smsSenderIsValid) {

        if (task.Detail.Action !== 1 || trusted) {
          const serverObj = Object.assign({}, task)
          const freqObj = Object.assign({}, task.Frequency)
          const detailObj = Object.assign({}, task.Detail)

          delete serverObj.Id
          delete serverObj.nameIsDiry
          delete serverObj.isDirty
          delete serverObj.enableIdFieldUTCCode
          delete serverObj.isDirtyDetailAction
          delete freqObj.ChoosenDays

          if (task.EndDate === '' || task.EndDate === null) {
            delete serverObj.EndDate
          } else {
            if (task.EndDate.indexOf('T') > -1) {
              const t = task.EndDate.split('T')
              serverObj.EndDate = t[0] + 'T00:00:00.000Z'
            }
          }

          if (task.StartDate !== '' && task.StartDate.indexOf('T') > -1) {
            const t = task.StartDate.split('T')
            serverObj.StartDate = t[0] + 'T00:00:00.000Z'
          }

          if (task.NextCalcRunDate === '') {
            delete serverObj.NextCalcRunDate
          }

          if (task.NextRealRunDate === '') {
            delete serverObj.NextRealRunDate
          }

          if (task.Frequency.BlackoutEndHour === '') {
            delete freqObj.BlackoutEndHour
          }
          if (task.Frequency.BlackoutStartHour === '') {
            delete freqObj.BlackoutStartHour
          }

          if (
            'TaskApplyConditionsEvent' in task.Detail &&
            task.Detail.TaskApplyConditionsEvent !== null &&
            task.Detail.TaskApplyConditionsEvent.IdEventFilter <= 0
          ) {
            delete detailObj.TaskApplyConditionsEvent
          }

          if (
            'TaskApplyConditionsField' in task.Detail &&
            task.Detail.TaskApplyConditionsField !== null &&
            task.Detail.TaskApplyConditionsField.IdFieldFilter === 0 &&
            task.Detail.TaskApplyConditionsField.IdField === 0 &&
            task.Detail.TaskApplyConditionsField.FieldValue === '' &&
            task.Detail.TaskApplyConditionsField.FieldType === 0
          ) {
            delete detailObj.TaskApplyConditionsField
          }

          if (!task.Detail.TaskApplyConditionsFilter) {
            detailObj.TaskApplyConditionsFilter = []
          }

          detailObj.GroupsCondition = !task.Detail.Group
            ? false
            : task.Detail.Group.length > 0
          detailObj.FiltersCondition = !task.Detail.Filter
            ? false
            : task.Detail.Filter.length > 0

          serverObj.Frequency = freqObj
          serverObj.Detail = detailObj

          let resp

          if (idTask === 0) {
            resp = await saveTask(serverObj)
            toastShow(
              getIntl().formatMessage({
                id: 'Load.Task.Created'
              }),
              TOAST_VARIANT_SUCCESS,
              'LoadTaskCreated'
            )
          } else {
            resp = await updateTask(idTask, serverObj)
            toastShow(
              getIntl().formatMessage({
                id: 'Load.Alerts.SuccessUpdate'
              }),
              TOAST_VARIANT_SUCCESS,
              'LoadTaskSuccessUpdate'
            )
          }
          if (serverObj.Enabled) {
            pendoTrack('Task  Active', {})
          }
          ret = true

          set(exceptionsState, (prev) => ({
            ...prev,
            isDirty: false
          }))

          set(taskConditionsState, (prev) => ({
            ...prev,
            isDirty: false
          }))

          set(senderConfigState, (prev) => ({
            ...prev,
            isDirty: false
          }))

          set(modalEndConditionState, (prev) => ({
            ...prev,
            isDirty: false
          }))

          set(taskPanelFrequencyState, (prev) => ({
            ...prev,
            isDirty: false
          }))

          set(taskState, (prev) => ({
            ...prev,
            isDirty: false,
            nameIsDiry: false,
            isDirtyDetailAction: false
          }))

          set(pageState, (prev) => ({
            ...prev,
            idTask: resp.Id
          }))
        }
      }
    } catch (error) {
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
      logAppError({
        appError: error,
        Component: 'Task',
        Method: 'saveTask'
      })
    }
    set(pageState, (prev) => ({
      ...prev,
      loading: false,
      exitPage
    }))
    return ret
  }

export const setStatusTaskCallback =
  ({ set }) =>
  async (idTask, status) => {
    set(pageState, (prev) => ({
      ...prev,
      loading: true
    }))

    try {
      const res = await setTaskEnable(idTask, { Enable: status })
      if (res.Result) {
        set(taskState, (prev) => ({
          ...prev,
          Enabled: status
        }))
        if (status) {
          pendoTrack('Task  Active', {})
        }
      }
    } catch (error) {
      logAppError({
        Component: 'Tasks',
        Method: 'setStatusTask',
        appError: error
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }
    set(pageState, (prev) => ({
      ...prev,
      loading: false
    }))
  }

export const simulateCallback =
  ({ set }) =>
  async (idTask) => {
    try {
      const res = await simulate(idTask)

      set(modalSimulate, (prev) => ({
        ...prev,
        idSimulate: res.Result
      }))
    } catch (error) {
      logAppError({
        appError: error
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }
  }

export const simulateAsyncTaskCallback =
  ({ set, snapshot }) =>
  async (idSimulate) => {
    const { currentIteration } = await snapshot.getPromise(modalSimulate)
    try {
      const res = await simulateAsync(idSimulate)

      const m = JSON.parse(res.Metadata)
      let p = 'Processed' in m ? m.Processed : undefined
      let d = 'Discarded' in m ? m.Discarded : undefined

      if (currentIteration >= POLLING_MAX_ITERATION || res.Status === 'Error') {
        toastShow(
          getIntl().formatMessage({
            id: 'Load.Alerts.TaskSimulationError'
          }),
          TOAST_VARIANT_ERROR,
          'simulateAsyncTaskCallbackKO'
        )
        p = '-'
        d = '-'
      }

      set(modalSimulate, (prev) => ({
        ...prev,
        currentIteration: prev.currentIteration + 1,
        interval: Math.min(prev.interval * 2, POLLING_MAX_INTERVAL),
        simulateStatus: res.Status,
        simulateProcessed: p,
        simulateDiscarded: d
      }))
    } catch (error) {
      logAppError({
        appError: error
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }
  }

export const updateTaskStep2Callback =
  ({ set, snapshot }) =>
  async () => {
    try {
      const modalEndCondition = await snapshot.getPromise(
        modalEndConditionState
      )
      const task = await snapshot.getPromise(taskState)
      const senderConfig = await snapshot.getPromise(senderConfigState)
      const { idTask } = await snapshot.getPromise(pageState)

      updateTaskStep2(
        modalEndCondition,
        task,
        senderConfig,
        idTask,
        set,
        taskState,
        idTask > 0
      )
    } catch (error) {
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }
  }

const updateTaskStep2 = (
  modalEndConditionState,
  task,
  senderConfig,
  idTask,
  set,
  stateToSet,
  save
) => {
  let FromGroup = 0
  let ToGroup = 0
  let Sender = ''
  let SenderName = ''
  let ReplyTo = ''
  let CustomSender = false
  let IdMessage = 0
  let IdSenderNameField = 0
  let IdSenderEmailField = 0

  switch (modalEndConditionState.check) {
    case DO_NOTHING:
      FromGroup = -1
      ToGroup = 0
      break
    case COPY:
      FromGroup = -1
      ToGroup = modalEndConditionState.copyValue.value
      break
    case MOVE:
      FromGroup = modalEndConditionState.moveFromValue.value
      ToGroup = modalEndConditionState.moveToValue.value
      break
    case EMPTYGROUP:
      FromGroup = modalEndConditionState.emptyValue.value
      ToGroup = -1
      break
  }
  if (task.Detail.Action === ACTION_SEND_MESSAGE) {
    Sender = senderConfig.SenderEmail
    SenderName = senderConfig.SenderName
    ReplyTo = senderConfig.SenderReplyTo
    CustomSender = senderConfig.CustomSender
    IdMessage = senderConfig.IdMessage
    IdSenderNameField = senderConfig.IdSenderNameField
    IdSenderEmailField = senderConfig.IdSenderEmailField
  }
  if (task.Detail.Action === ACTION_SEND_SMS) {
    Sender = senderConfig.SenderNameSMS
    IdMessage = senderConfig.IdMessage
  }

  set(stateToSet, (prev) => ({
    ...prev,
    Detail: {
      ...prev.Detail,
      FromGroup,
      ToGroup,
      Sender,
      SenderName,
      ReplyTo,
      CustomSender,
      IdMessage,
      IdSenderNameField,
      IdSenderEmailField
    },
    saveTask: save
  }))
}

export const updateTaskStep3Callback =
  ({ set, snapshot }) =>
  async () => {
    try {
      const taskConditions = await snapshot.getPromise(taskConditionsState)
      const { idTask } = await snapshot.getPromise(pageState)

      updateTaskStep3(taskConditions, set, taskState, idTask > 0)
    } catch (error) {
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }
  }

const updateTaskStep3 = (taskConditions, set, stateToSet, save) => {
  const groups = taskConditions.IncludeGroups.map((m) => ({
    IdGroup: m,
    Action: 0
  }))
  Array.prototype.push.apply(
    groups,
    taskConditions.ExcludeGroups.map((m) => ({
      IdGroup: m,
      Action: 1
    }))
  )

  const taskApplyConditionsFilter = getTaskApplyConditionsFilter(taskConditions)

  set(stateToSet, (prev) => ({
    ...prev,
    Detail: {
      ...prev.Detail,
      FrequencySafeGuard:
        taskConditions.FrequencySafeGuard > 0
          ? taskConditions.FrequencySafeGuardHour
          : taskConditions.FrequencySafeGuard,
      ApplyConditionsRule: taskConditions.ApplyConditionsRule,
      Group: groups,
      Filter: taskConditions.Filters.map((m) => ({ IdFilter: m })),
      FilterConditionsRules: taskConditions.FilterConditionsRules,
      ApplyConditionsEvent: taskConditions.ApplyConditionsEvent,
      TaskApplyConditionsEvent: taskConditions.ApplyConditionsEvent
        ? taskConditions.TaskApplyConditionsEvent
        : prev.Detail.TaskApplyConditionsEvent,
      ApplyConditionsField: taskConditions.ApplyConditionsField,
      TaskApplyConditionsField: taskConditions.TaskApplyConditionsField
        ? taskConditions.TaskApplyConditionsField
        : prev.Detail.TaskApplyConditionsField,
      ApplyConditionsFilter: taskApplyConditionsFilter.length > 0,
      TaskApplyConditionsFilter:
        taskApplyConditionsFilter.length > 0
          ? taskApplyConditionsFilter
          : prev.Detail.TaskApplyConditionsFilter
    },
    saveTask: save
  }))
}

function getTaskApplyConditionsFilter(taskConditions) {
  const taskApplyConditionsFilter = []
  if (taskConditions.AnagFilterTrue) {
    taskApplyConditionsFilter.push({
      IdFilter: taskConditions.AnagFilterTrueId,
      TypeOfFilter: 0,
      Action: 0
    })
  }
  if (taskConditions.AnagFilterFalse) {
    taskApplyConditionsFilter.push({
      IdFilter: taskConditions.AnagFilterFalseId,
      TypeOfFilter: 0,
      Action: 1
    })
  }
  if (taskConditions.OtherFilterTrue) {
    taskApplyConditionsFilter.push({
      IdFilter: taskConditions.OtherFilterTrueId,
      TypeOfFilter: 1,
      Action: 0
    })
  }
  if (taskConditions.OtherFilterFalse) {
    taskApplyConditionsFilter.push({
      IdFilter: taskConditions.OtherFilterFalseId,
      TypeOfFilter: 1,
      Action: 1
    })
  }
  return taskApplyConditionsFilter
}

export const updateTaskStep4Callback =
  ({ set, snapshot }) =>
  async () => {
    try {
      const exceptionState = await snapshot.getPromise(exceptionsState)
      const task = await snapshot.getPromise(taskState)
      // salva sempre
      updateTaskStep4(task, set, taskState, exceptionState, true)
    } catch (error) {
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }
  }

const updateTaskStep4 = (task, set, stateToSet, exceptionState, save) => {
  const FrequencyMonthlyChoosenDay = []
  const FrequencyWeeklyChoosenDay = []
  const FrequencyYearlyChoosenDay = []

  if (task.Frequency.KindDateFrequency === 'w') {
    task.Frequency.ChoosenDays.map((e) =>
      FrequencyWeeklyChoosenDay.push({ Day: e.DayOfWeek })
    )
  } else if (task.Frequency.KindDateFrequency === 'm') {
    task.Frequency.ChoosenDays.map((e) =>
      FrequencyMonthlyChoosenDay.push({
        DayOfMonth: e.FixedDay ? e.DayOfMonth : 0,
        DayOfWeek: e.FixedDay ? '' : e.DayOfWeek,
        WeekOfMonth: e.FixedDay ? '' : e.WeekOfMonth
      })
    )
  } else if (task.Frequency.KindDateFrequency === 'y') {
    task.Frequency.ChoosenDays.map((e) =>
      FrequencyYearlyChoosenDay.push({
        Month: e.Month,
        DayOfMonth: e.FixedDay ? e.DayOfMonth : 0,
        DayOfWeek: e.FixedDay ? '' : e.DayOfWeek,
        WeekOfMonth: e.FixedDay ? '' : e.WeekOfMonth
      })
    )
  }

  set(stateToSet, (prev) => ({
    ...prev,
    StartDate: withoutOffsetToString(exceptionState.StartDate),
    EndDate:
      exceptionState.activiteFor === 'FromToDate'
        ? withoutOffsetToString(exceptionState.EndDate)
        : '',
    Frequency: {
      ...prev.Frequency,
      KindOfUrl: exceptionState.KindOfUrl,
      FrequencyBlackoutDate: exceptionState.FrequencyBlackoutDate,
      NotInWeekends: exceptionState.NotInWeekends,
      UrlFrequency: exceptionState.urlFrequencyEnabled
        ? exceptionState.UrlFrequency
        : 0,
      Url: exceptionState.urlFrequencyEnabled ? exceptionState.Url : '',
      BlackoutStartHour: exceptionState.frequencyBlackoutHourEnabled
        ? '1900-01-01T' +
          (exceptionState.startBOTime.hours < 10
            ? '0' + exceptionState.startBOTime.hours
            : exceptionState.startBOTime.hours) +
          ':' +
          (exceptionState.startBOTime.minutes < 10
            ? '0' + exceptionState.startBOTime.minutes
            : exceptionState.startBOTime.minutes) +
          ':00Z'
        : '',
      BlackoutEndHour: exceptionState.frequencyBlackoutHourEnabled
        ? '1900-01-01T' +
          (exceptionState.endBOTime.hours < 10
            ? '0' + exceptionState.endBOTime.hours
            : exceptionState.endBOTime.hours) +
          ':' +
          (exceptionState.endBOTime.minutes < 10
            ? '0' + exceptionState.endBOTime.minutes
            : exceptionState.endBOTime.minutes) +
          ':00Z'
        : '',
      FrequencyMonthlyChoosenDay,
      FrequencyWeeklyChoosenDay,
      FrequencyYearlyChoosenDay
    },
    saveTask: save
  }))
}
